import { get } from '../../../libs/Requests';

export function getFileUrl(fileName: string) {
  return get(`/download/${fileName}`).then(async (data) => {
    const _ = await data.json();

    return _.fileUrl;
  });
}
